import {DateRange} from 'raain-ui';

export function mapDateRangeToString(range: DateRange): 'hour' | 'day' | 'month' | 'year' {
    switch (range) {
        case DateRange.HOUR:
            return 'hour';
        case DateRange.DAY:
            return 'day';
        case DateRange.MONTH:
            return 'month';
        case DateRange.YEAR:
            return 'year';
        default:
            return 'year';
    }
}
